var price = 0;
var discount = 0;
var newPrice = 0;
var init = false;

var customJS = function() {
    document.addEventListener('cpb-add-to-cart', function(event) {
       window.location.href = "https://www.luckyscooters.com/discount/builderdiscount/?redirect=/cart";
    });
}

 /** 
   * Function wait CPB DOM elements to show up.
   * Work in modern browsers.
   * And execute callback.
   */
var cpbLoaded = function() {

    //console.log('CPB is loaded');
    customJS();
   
};

cpbLoaded();

document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function(event) {
 
  price = parseInt($(".cpb-product-price").text().split("$")[1]);
  
  if(!init){
    
    init = true;
    
    $(".cpb-product-price").append("<div class='new-price'></div>");
    $(".cpb-product-price").prepend("Retail Price: ");

    discount = 0;
  
  }else{
    discount = parseFloat(price * 0.15); //(price * .22) - .42; (price * .40) - .34 //(price * .034);
  }
  newPrice = price - discount; 
  $(".new-price").html("<span style='color: red;'>Your Price:</span> $" + newPrice.toFixed(2) );
  
  /*var check = $(".cpb-product-price").html().split("<")[0];
  alert('TEST:  ' + check);*/

});

